export default "__VITE_ASSET__D8zRhd$v__"